// extracted by mini-css-extract-plugin
module.exports =  {"volume-control":"uEmXLK3","volumeControl":"uEmXLK3","on":"iMHrbAl","off":"ISD2Azs"};